import React from "react";
import {
	Datagrid,
	List,
	TextField,
	EmailField,
	Filter,
	SelectInput,
	ReferenceInput,
} from "react-admin";

const UserFilters = (props) => (
	<Filter {...props}>
		<ReferenceInput source="entity_id" reference="entity">
			<SelectInput label="Organisation" optionText="name" />
		</ReferenceInput>
	</Filter>
);

const UserList = (props) => (
	<List {...props} filters={<UserFilters />}>
		<Datagrid rowClick="show">
			<TextField source="id" />
			<TextField source="firstname" label="Prénom" />
			<TextField source="lastname" label="Nom" />
			<EmailField source="email" />
		</Datagrid>
	</List>
);

export default UserList;
